/* eslint-disable indent */
export const ERRORS = {
  DEFAULT: {
    DEFAULT: {
      field: '',
      errorMessage: 'Something went wrong. Please contact support.'
    },
    // 400s
    400: {
      field: '',
      errorMessage: 'Request is not valid. Please contact support.'
    },
    401: {
      field: '',
      errorMessage: 'Unauthorized access. Please contact support.'
    },
    404: {
      field: '',
      errorMessage: "Can't find requested resource. Please contact support."
    },

    // 500s
    500: {
      field: '',
      errorMessage: 'Internal server error. Please try again later'
    },
    501: {
      field: '',
      errorMessage: 'Service unavailable. Please try again later'
    }
  },
  AUTH_MODULE: {
    DEFAULT: {
      400: {
        'MS-4001': {
          field: '',
          errorMessage: 'User is not valid. please contact support.'
        }
      },
      500: {
        'MS-5000': {
          field: '',
          errorMessage: 'SMS Gateway error. Please try again later'
        }
      }
    },
    registerUser: {
      409: {
        'Invalid Request': {
          errorMessage:
            // eslint-disable-next-line quotes
            "Email already registered, if you can't remember you password, please email us on support@ofintk.com",
          type: 'warning',
          field: 'email'
        }
      }
    },
    signUpUser: {
      409: {
        'Invalid Request': {
          errorMessage:
            // eslint-disable-next-line quotes
            "Email already registered, if you can't remember you password, please email us on support@ofintk.com",
          type: 'warning',
          field: 'email'
        }
      }
    },
    loginUser: {
      409: {
        'Invalid Request': {
          errorMessage: 'Incorrect email or password, please try again.',
          type: 'warning',
          field: 'email'
        }
      },
      400: {
        'Invalid Request': {
          errorMessage: 'Incorrect email or password, please try again.',
          type: 'warning',
          field: 'email'
        }
      },
      423: {
        DEFAULT: {
          errorMessage: 'AUTH_MODULE.LOGIN_CONTAINER.MAX_ATTEMPTS_ERROR_MESSAGE',
          type: 'warning',
          field: 'email'
        },
        'Bad Request': {
          errorMessage: 'AUTH_MODULE.LOGIN_CONTAINER.MAX_ATTEMPTS_ERROR_MESSAGE',
          type: 'warning',
          field: 'email'
        },
        MAX_LOGIN_ATTEMPTS: {
          errorMessage: 'AUTH_MODULE.LOGIN_CONTAINER.MAX_ATTEMPTS_ERROR_MESSAGE',
          type: 'warning',
          field: 'email'
        }
      }
    }
  },
  MERCHANT_MODULE: {
    DEFAULT: {
      field: '',
      errorMessage: 'Something went wrong. Please contact support.'
    },
    // 400s
    400: {
      field: '',
      errorMessage: 'Request is not valid. Please contact merchant support.'
    },
    401: {
      field: '',
      errorMessage: 'Unauthorized access. Please contact support.'
    },
    404: {
      field: '',
      errorMessage: "Can't find requested resource. Please contact support."
    },

    // 500s
    500: {
      field: '',
      errorMessage: 'Internal server error. Please try again later'
    },
    501: {
      field: '',
      errorMessage: 'Service unavailable. Please try again later'
    },
    createCompanyUser: {
      409: {
        DUPLICATE_PHONE: {
          errorMessage: 'MERCHANT_MODULE.ERRORS.USER_PHONE_ALREADY_EXISTS',
          field: 'phone'
        },
        DUPLICATE_EMAIL: {
          errorMessage: 'MERCHANT_MODULE.ERRORS.USER_EMAIL_ALREADY_EXISTS',
          field: 'email'
        }
      },
      500: {
        SERVER_ERROR: {
          errorMessage: 'This User already exists'
        }
      }
    },
    addUnverifiedUser: {
      403: {
        DUPLICATE_PHONE: {
          errorMessage: 'MERCHANT_MODULE.ERRORS.USER_PHONE_ALREADY_EXISTS',
          field: 'phone'
        },
        DUPLICATE_EMAIL: {
          errorMessage: 'MERCHANT_MODULE.ERRORS.USER_EMAIL_ALREADY_EXISTS',
          field: 'email'
        }
      },
      409: {
        DUPLICATE_PHONE: {
          errorMessage: 'MERCHANT_MODULE.ERRORS.USER_PHONE_ALREADY_EXISTS',
          field: 'phone'
        },
        DUPLICATE_EMAIL: {
          errorMessage: 'MERCHANT_MODULE.ERRORS.USER_EMAIL_ALREADY_EXISTS',
          field: 'email'
        }
      }
    }
  },
  CUSTOMERS_MODULE: {
    createCustomerPersonalData: {
      409: {
        'Bad Request': {
          errorMessage: 'Customer with this email already exists'
        }
      }
    },
    createCustomerFinancialData: {
      409: {
        'Bad Request': {
          errorMessage: 'Customer with this email already exists'
        }
      }
    },
    createCustomerApplication: {
      409: {
        'Bad Request': {
          errorMessage: 'An Application with the same data already exists'
        }
      }
    }
  },
  FINANCE_APPLICATIONS_MODULE: {
    getCustomerPersonalDataById: {
      404: {
        'Not Found': {
          errorMessage: "user doesn't have a customer profile"
        }
      }
    },
    createAutoProductDetails: {
      404: {
        'Bad Request': {
          errorMessage: 'Car chassis already exists'
        }
      }
    }
  },
  USER_MANAGEMENT_MODULE: {
    registerUser: {
      409: {
        'Bad Request': {
          errorMessage: 'User with this phone/email already exists'
        }
      }
    }
  },
  BRANDS_MODULE: {
    createNewBrand: {
      400: {
        'Bad Request': {
          errorMessage: 'Brand with this name already exists'
        }
      }
    },
    createNewBrandModel: {
      400: {
        'Bad Request': {
          errorMessage: 'Brand model with this name already exists'
        }
      }
    },
    createNewBrandModelCategory: {
      400: {
        'Bad Request': {
          errorMessage: 'Brand model category with this name already exists'
        }
      }
    }
  },
  PRODUCTS_MODULE: {
    updateAutoProduct: {
      404: {
        'Bad Request': {
          errorMessage: 'Car chassis already exists'
        }
      }
    }
  },
  CASH_OUT_MODULE: {
    createTransaction: {
      400: {
        CLIENT_ERROR: {
          errorMessage: 'Cashout amount is greater than wallet amount'
        }
      }
    }
  },
  REFERRALS_MODULE: {
    createReferral: {
      409: {
        CLIENT_ERROR: {
          errorMessage: 'User role is not allowed to be referral'
        }
      }
    }
  }
};
